import Vue from 'vue'
import Router from 'vue-router'
import wap from './modules/wap'
import wapErp from './modules/wapErp'
import fabricShow from '/page/Design/fabricShow'

const Index = () => import('/page/index.vue')
const Login = () => import('/page/Login/login.vue')
const Home = () => import('/page/Home/home.vue')
const NavIndex = () => import('/page/Home/navIndex.vue')
const NavIndexKor = () => import('/page/Home/navIndex_kor.vue')
const Secondary = () => import('/page/Home/secondary.vue')
const Wsai = () => import('/page/Home/wsai.vue')

const Shows = () => import('/page/Home/shows.vue')
const Welcome = () => import('/page/Home/welcome.vue')
const GoodS = () => import('/page/Goods/goods.vue')
const GoodSearch = () => import('/page/Goods/goodSearch.vue')
const DesignSearch = () => import('/page/Design/designSearch.vue')
const Chanels = () => import('/page/Goods/chanels.vue')
const ShareChanel = () => import('/page/Goods/shareChanel.vue')
const goodsDetails = () => import('/page/Goods/goodsDetails.vue')
const ShareGoodsDetails = () => import('/page/Goods/shareGoodsDetails.vue')
const ShapeDetails = () => import('/page/Goods/shapeDetails.vue')
const ShareShapeDetails = () => import('/page/Goods/shareShapeDetails.vue')
const Verify = () => import('/page/Home/verify.vue')
const History = () => import('/page/UserBase/history.vue')
const MyOrder = () => import('/page/UserBase/myOrder.vue')
const MyGarmentOrder = () => import('/page/UserBase/myGarmentOrder.vue')
const MyGarmentSample = () => import('/page/UserBase/myGarmentSample.vue')
const MySourcing = import('/page/UserBase/mySourcing.vue')
const MyLapDip = () => import('/page/UserBase/myLapDip.vue')
const MySample = () => import('/page/UserBase/mySample.vue')
const MyFabric = () => import('/page/UserBase/myFabric.vue')

// New empty pages for My Souring
const SouringFabric = () => import('/page/UserBase/souringFabric.vue')
const SouringGarment = () => import('/page/UserBase/souringGarment.vue')

const RefreshSearch = () => import('/page/Refresh/refreshsearch.vue')
const RefreshGoods = () => import('/page/Refresh/refreshgoods.vue')
const DesignList = () => import('/page/Design/list.vue')
const ChanelHome = () => import('/page/Design/chanelHome.vue')
const CommonChanel = () => import('/page/Design/commonChanel.vue')
const PrivateChanel = () => import('/page/Design/privateChanel.vue')
const UserInfo = () => import('/page/UserBase/info.vue')

const InspectionReport = () => import('/page/UserBase/inspectionReport.vue')

const Comment = () => import('/page/UserBase/comment')
const myDesign = () => import('/page/UserBase/myDesign')
const vrShowroom = () => import('/page/UserBase/vrShowroom')
const VRChanel = () => import('/page/Design/vrChanel')

const Favorite = () => import('/page/UserBase/favorite.vue')
const FavoriteStyle = () => import('/page/UserBase/favoriteStyle.vue')
const Setting = () => import('/page/UserBase/setting.vue')
const help = () => import('/page/UserBase/help.vue')
const StyleShow = () => import('/page/Design/styleShow')
const WesAiCreate = () => import('/page/AiCreate/index.vue')
const StyleShow2 = () => import('/page/Design/styleShow2')
const styleShowRecover = () => import('/page/Design/styleShowRecover')
const styleShowRecoverEdit = () => import('/page/Design/styleShowRecoverEdit')

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      name: 'index',
      redirect: '/nav',
      children: [
        // {path: 'home', component: Home},
        {
          path: 'goods',
          component: GoodS,
          meta: {
            title: 'Goods'
          }
        },
        {
          path: 'goodSearch',
          component: GoodSearch,
          meta: {
            title: 'Goods'
          }
        },
        {
          path: '/welcome',
          name: 'welcome',
          component: Welcome,
          meta: {
            title: 'welcome'
          }
        },
        // {path: 'thanks', name: 'thanks', component: Thanks},
        {
          path: '/refreshgoods',
          name: 'refreshgoods',
          component: RefreshGoods,
          meta: {
            title: 'Goods'
          }
        },
        {
          path: '/comment',
          name: 'comment',
          component: Comment,
          meta: {
            title: 'Personal Centre'
          }
        }
      ]
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: MyOrder,
      meta: {
        title: 'MyFabricOrder'
      }
    },
    {
      path: '/wesAiCreate',
      name: 'wesAiCreate',
      component: WesAiCreate,
      meta: {
        title: 'wesAiCreate'
      }
    },
    {
      path: '/myGarmentOrder',
      name: 'myGarmentOrder',
      component: MyGarmentOrder,
      meta: {
        title: 'MyGarmentOrder'
      }
    },
    {
      path: '/myGarmentSample',
      name: 'myGarmentSample',
      component: MyGarmentSample,
      meta: {
        title: 'MyGarmentOrder'
      }
    },
    {
      path: '/favorite',
      name: 'favorite',
      component: Favorite,
      meta: {
        title: 'My favorite'
      }
    },
    {
      path: '/favoriteStyle',
      name: 'favoriteStyle',
      component: FavoriteStyle,
      meta: {
        title: 'My Style favorite'
      }
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: UserInfo,
      meta: {
        title: 'Personal Centre'
      }
    },
    {
      path: '/myDesign',
      name: 'myDesign',
      component: myDesign,
      meta: {
        title: 'Personal Centre'
      }
    },
    {
      path: '/vrShowroom',
      name: 'vrShowroom',
      component: vrShowroom,
      meta: {
        title: 'VR Showroom'
      }
    },
    {
      path: '/mySourcing',
      name: 'mySourcing',
      component: MySourcing,
      meta: {
        title: 'MySourcing'
      }
    },
    {
      path: '/souringFabric',
      name: 'souringFabric',
      component: SouringFabric,
      meta: {
        title: 'Souring Fabric'
      }
    },
    {
      path: '/souringGarment',
      name: 'souringGarment',
      component: SouringGarment,
      meta: {
        title: 'Souring Garment'
      }
    },
    {
      path: '/myLapDip',
      name: 'myLapDip',
      component: MyLapDip,
      meta: {
        title: 'MyLapDip'
      }
    },
    {
      path: '/mySample',
      name: 'mySample',
      component: MySample,
      meta: {
        title: 'MySample'
      }
    },
    {
      path: '/myFabric',
      name: 'myFabric',
      component: MyFabric,
      meta: {
        title: 'MyFabric'
      }
    },
    {
      path: '/setting',
      name: 'setting',
      component: Setting,
      meta: {
        title: 'Personal Centre'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: help,
      meta: {
        title: 'Help'
      }
    },
    {
      path: '/history',
      name: 'history',
      component: History,
      meta: {
        title: 'Consult History'
      }
    },
    {
      path: '/goodsDetails',
      name: 'goodsDetails',
      component: goodsDetails,
      meta: {
        title: 'Goods Detail'
      }
    },
    {
      path: '/shareGoodsDetails',
      name: 'shareGoodsDetails',
      component: ShareGoodsDetails,
      meta: {
        title: 'Goods Detail'
      }
    },
    {
      path: '/shareShapeDetails',
      name: 'shareShapeDetails',
      component: ShareShapeDetails,
      meta: {
        title: 'Style Detail'
      }
    },
    {
      path: '/chanels',
      component: Chanels,
      meta: {
        title: 'Chanels'
      }
    },
    {
      path: '/shareChanel',
      name: 'shareChanel',
      component: ShareChanel,
      meta: {
        title: 'Chanels'
      }
    },
    { path: '/secondary', name: 'secondary', component: Secondary },
    { path: '/wsai', name: 'wsai', component: Wsai },
    { path: '/nav', name: 'nav', component: NavIndex },
    { path: '/navkor', name: 'navkor', component: NavIndexKor },
    { path: '/verify', name: 'verify', component: Verify },
    // { path: '/history', name: 'history', component: History },
    { path: '/shows', name: 'shows', component: Shows },
    { path: '/home', name: 'home', component: Home },
    { path: '/login', name: 'login', component: Login },
    { path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch },
    {
      path: '/designlist',
      name: 'designlist',
      component: DesignList,
      meta: {
        title: 'Style lib'
      }
    },
    {
      path: '/designSearch',
      name: 'designSearch',
      component: DesignSearch,
      meta: {
        title: 'Style Search'
      }
    },
    { path: '/chanelHome', name: 'chanelHome', component: ChanelHome },
    {
      path: '/commonChanel',
      name: 'commonChanel',
      component: CommonChanel,
      meta: {
        title: 'Public ShowRoom'
      }
    },
    {
      path: '/shapeDetails',
      name: 'shapeDetails',
      component: ShapeDetails,
      meta: {
        title: 'Style Detail'
      }
    },
    {
      path: '/privateChanel',
      name: 'privateChanel',
      component: PrivateChanel,
      meta: {
        title: 'Private ShowRoom'
      }
    },
    {
      path: '/VRChanel',
      name: 'VRChanel',
      component: VRChanel,
      meta: {
        title: 'VR ShowRoom'
      }
    },
    {
      path: '/styleShow',
      name: 'styleShow',
      component: StyleShow,
      meta: {
        title: 'Style Show'
      }
    },
    { path: '/styleShow2', name: 'styleShow2', component: StyleShow2 },
    { path: '/styleShowRecover', name: 'styleShowRecover', component: styleShowRecover },
    { path: '/styleShowRecoverEdit', name: 'styleShowRecoverEdit', component: styleShowRecoverEdit },
    { path: '/fabricShow', name: 'fabricShow', component: fabricShow },
    { path: '/inspectionReport', name: 'inspectionReport', component: InspectionReport },
    wap,
    wapErp,
    { path: '*', redirect: '/nav' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js